export class NoResponseError extends Error {}
